import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { ScrollToTop } from './components/ScrollToTop'
import { SiteChrome } from './components/SiteChrome'
import { Contact } from './pages/Contact'
import { Download } from './pages/Download'
import { DownloadApp } from './pages/DownloadApp'
import { Home } from './pages/Home'
import { Privacy } from './pages/Privacy'
import { StationDetail } from './pages/StationDetail'
import { Stations } from './pages/Stations'
import { TopicPage } from './pages/TopicPage'
import { Terms } from './pages/Terms'
import { TOPICS } from './seo/topics'

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route element={<SiteChrome />}>
          <Route index element={<Home />} />
          <Route path="stations" element={<Stations />} />
          <Route path="stations/:slug" element={<StationDetail />} />
          {TOPICS.map((topic) => (
            <Route key={topic.path} path={topic.path.slice(1)} element={<TopicPage topic={topic} />} />
          ))}
          <Route path="download" element={<Download />} />
          <Route path="contact" element={<Contact />} />
          <Route path="privacy" element={<Privacy />} />
          <Route path="terms" element={<Terms />} />
        </Route>
        <Route path="download-app" element={<DownloadApp />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  )
}
